import { Component, OnInit } from '@angular/core';
import { CodeEventGroup, ClipData, PublishedMatch, Match } from '../../../models';
import { Router, ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs/operators';
import { ClipViewerDialogComponent } from '../../../common-components/dialogs';
import { MatDialog } from '@angular/material';
import { Subject } from 'rxjs/Subject';
import { PublishedMatchService, AuthService } from '../../../services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'public-host',
  templateUrl: './public-host.component.html',
  styleUrls: ['./public-host.component.css']
})
export class PublicHostComponent implements OnInit {
  match: PublishedMatch;
  playState$ = new Subject<boolean>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private publishedMatchService: PublishedMatchService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    const matchKey = this.activatedRoute.snapshot.params['id'];
    this.getMatch(matchKey);
  }

  getMatch(matchKey: string) {
    console.info('[PublicHost] fetching: ', matchKey);
    this.publishedMatchService.getByMatchId(matchKey).subscribe(match => {
      this.match = { ...match };
      console.info('[PublicHost] getMatch: ', match);
    });
  }

  onShowPlaylist(group: CodeEventGroup) {
    const match = this.match;
    const clips = group.events.map(e => {
      const clip = { ...e };
      return clip;
    });

    const clipData = { match, clips, name: group.eventType } as ClipData;

    this.playState$.next(false);

    const dialogRef = this.dialog.open(ClipViewerDialogComponent, {
      height: '580px',
      width: '1010px',
      data: clipData
    });
  }

  onClone(match: PublishedMatch) {
    const clone = confirm("Are you sure you want to clone this game?");
    if (clone) {
      // this.matchService.addMatch(match).then(r => {
      //   this.router.navigateByUrl("/matches");
      // });

      this.router.navigateByUrl("/matches");
    }
  }

  onAddFavorite(match: PublishedMatch) {
    const clone = confirm("Are you sure you want to add this game to your favorites?");
    if (clone) {
      // this.matchService.addMatch(match).then(r => {
      //   this.router.navigateByUrl("/matches");
      // });

      this.router.navigateByUrl("/matches");
    }
  }

  onRemoveFavorite(match: PublishedMatch) {
    const clone = confirm("Are you sure you want to remove this game to your favorites?");
    if (clone) {
      // this.matchService.addMatch(match).then(r => {
      //   this.router.navigateByUrl("/matches");
      // });

      this.router.navigateByUrl("/matches");
    }
  }
}
